<template>
    <div>
        <v-server-table ref="historyTable" :url="url" :columns="columns" :options="options">

            <template slot="user_id" slot-scope="props">
                <template v-if="props.row.user_id">
                    {{ props.row.FirstName }} {{ props.row.LastName }}
                </template>
                <template v-else>
                    [SYSTEM]
                </template>
            </template>

            <template slot="created_at" slot-scope="props">
                {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {

        props: {

            recordType: {
                type: String,
                required: true,
            },

            recordId: {
                type: Number,
                //required: true,
            },

            historyType: {
                type: String,
                default: null
            },

        },

        data() {
            return {
                userTimezone: this.$store.state.user.timezone,
                columns: ['user_id', 'created_at', 'note', 'attribute_name', 'attribute_old_value', 'attribute_new_value'],
                options: {
                    headings: {
                        history_id: 'Actions',
                        user_id: 'User',
                        created_at: 'Timestamp',
                        attribute_name: 'Field',
                        attribute_old_value: 'Old Value(s)',
                        attribute_new_value: 'New Value(s)',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'history.history_id',
                    },
                    requestAdapter: (data) => {
                        //INclude the asset
                        //data.recordType = this.recordType
                        //data.recordId = this.recordId
                        if(this.historyType)
                        {
                            data.history_type = this.historyType;
                        }

                        //Send it
                        return data;
                    },
                    responseAdapter: (response) => {
                        //Emit the Total Count
                        this.$emit('historyCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    uniqueKey: 'history_id',
                },
            }
        },

        computed: {
            url(){
                //SEnd it
                if(!this.recordId)
                {
                    return `/history/list/${this.recordType}`;
                }

                //Send full
                return `/history/list/${this.recordType}/${this.recordId}`;
            }
        },

        methods: {

            filtersChanged: function (filters) {
                //Set the store
                this.$store.commit('setFilters', {key: 'clientFilters', filters: filters});

                //Set the data
                this.$refs.historyTable.getData();
            },

            filtersCleared: function (filters) {
                this.$store.commit('setFilters', {key: 'clientFilters', filters: {
                    'client.DivisionId': [],
                }});

                this.$refs.historyTable.refresh();
            },
        },
    }
</script>
